// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28eb64ba","667":"17390ea6"}[chunkId] + ".chunk.js";
};